import { Logger } from './logger';

export const injectSprite = async (id: string, path: string) => {
    try {
        if (typeof document === 'undefined') return;

        const svgText = await fetch(path).then((r) => r.text());
        const temp = document.createElement('div');
        temp.innerHTML = svgText;

        const incomingSvg = temp.querySelector('svg');
        if (!incomingSvg) return;

        let container = document.getElementById(id);
        if (!container) {
            container = document.createElement('div');
            container.id = id;
            container.className = 'hidden';
            container.style.cssText =
                'position:absolute;width:0;height:0;overflow:hidden;';
            container.appendChild(incomingSvg);
            document.body.prepend(container);
            return;
        }

        const existingSvg = container.querySelector('svg');
        if (!existingSvg) {
            container.appendChild(incomingSvg);
            return;
        }

        incomingSvg.querySelectorAll('symbol').forEach((s) => {
            try {
                if (!document.getElementById(s.id)) {
                    existingSvg.appendChild(s);
                }
            } catch {
                // Empty to avoid console errors
            }
        });
    } catch (error) {
        Logger.error({ error });
    }
};
